import classNames from 'classnames';
import {EDITOR_MODE} from '@/Constant';

import DocTitle from './DocTitle';
import styles from './index.module.scss';
import * as store from '@/store';
import {Template} from '@/interface';

import kuPiper from '@/middleware/kuPiper';
import DocContentWidthChange from '../DocContentWidthChange';

export interface IProps {
    repository: Repository;
    docGuid: string;
    mode: EDITOR_MODE;
    updateDoTitle: (title?: string) => void;
    hasEditPermission?: boolean;
    isWideScreenMode?: boolean;
    isNew?: boolean;
    curDocument?: WizDocument;
    isKuShareMode?: string;
    isCardView?: boolean;
    titleNode?: any;
    handleTplClick: (template: Template, onCloseModal: () => void) => void;
}

const EditorBanner: React.FC<IProps> = ({
    mode,
    docGuid,
    repository,
    updateDoTitle,
    hasEditPermission,
    isWideScreenMode,
    isKuShareMode,
    isNew,
    curDocument,
    isCardView,
    titleNode,
    handleTplClick,
}) => {
    const showTitle = store.getSDKShowDocumentTitle();
    return (
        <div
            id="EditorBanner"
            className={classNames(
                styles.root,
                isKuShareMode && styles.kuShare,
                isWideScreenMode && styles.wide,
                isCardView && styles.card)}
        >
            <DocContentWidthChange />
            {
                curDocument && showTitle && <DocTitle
                    mode={mode}
                    repository={repository}
                    updateDoTitle={updateDoTitle}
                    hasEditPermission={hasEditPermission}
                    isNew={isNew}
                    curDocument={curDocument}
                    isCardView={isCardView}
                    titleNode={titleNode}
                />
            }
            {
                kuPiper.openNormalAddSlot(
                    {
                        scope: kuPiper.slotScopeMap.DocumentEditor,
                        position: kuPiper.slotPositionMap.DocumentEditor.Top,
                        data: {
                            isNew,
                            handleTplClick,
                        },
                    }
                )
            }
        </div>
    );
};

export default store.connect([
    store.KEYS.IS_KU_SHARE_MODE,
])(EditorBanner);
